(() => {
  if (window.lohrizReviewVotesBound) return;
  window.lohrizReviewVotesBound = true;
  const pending = new Set(), slow = new Set(), records = new Map(), feedback = new Map();
  const unconfirmed = 'Your vote could not be confirmed. Voting on this review is paused to avoid counting it twice.';
  const awaitingConfirmation = 'We have not received confirmation of your vote yet. Voting on this review is paused to avoid counting it twice.';
  const storedVotes = () => {
    try {
      const value = JSON.parse(localStorage.getItem('jdgm_thumb_votes') || '{}');
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    } catch { return {}; }
  };
  const save = (id, record) => {
    records.set(id, record);
    try {
      const votes = storedVotes();
      votes[id] = record;
      localStorage.setItem('jdgm_thumb_votes', JSON.stringify(votes));
    } catch { /* Keep the guard in memory when storage is unavailable. */ }
  };
  const restore = () => {
    const stored = storedVotes();
    document.querySelectorAll('[data-review-votes]').forEach(group => {
      const id = group.dataset.reviewVotes, record = records.get(id) || stored?.[id];
      const busy = pending.has(id);
      if (busy && !slow.has(id)) group.setAttribute('aria-busy', 'true');
      else group.removeAttribute('aria-busy');
      group.querySelectorAll('button').forEach(button => {
        button.disabled = busy || !!record?.submitted || !!record?.unconfirmed;
        button.setAttribute('aria-pressed', String(!!record?.submitted && record.direction === button.dataset.rhpVote));
      });
      const status = group.querySelector('[data-vote-status]');
      const message = feedback.get(id) || (record?.unconfirmed ? awaitingConfirmation : '');
      if (status && status.textContent !== message) status.textContent = message;
      if (group.closest(':is([data-product-handle="loriz-premium-shilajit-honey"],[data-product-handle="premium-honey-sachets-individually-packed"],[data-product-handle="php-royal-honey-supplement"])')) {
        group.querySelectorAll('[data-vote-count]').forEach(count => {
          const direction = count.dataset.voteCount;
          count.hidden = !(Math.max(Number(count.textContent) || 0, record?.submitted ? Number(record[direction]) || 0 : 0) > 0);
        });
      }
      if (!record?.submitted) return;
      for (const direction of ['up', 'down']) {
        const count = group.querySelector(`[data-vote-count="${direction}"]`);
        if (count && Number(count.textContent) < Number(record[direction])) count.textContent = String(record[direction]);
      }
    });
  };
  const root = document.querySelector('[data-rhp-review-root]:is([data-product-handle="red-bull-extreme-honey"],:is([data-product-handle="loriz-premium-shilajit-honey"],[data-product-handle="premium-honey-sachets-individually-packed"],[data-product-handle="php-royal-honey-supplement"]))');
  if (root) new MutationObserver(restore).observe(root, { childList: true, subtree: true });
  restore();
  document.addEventListener('lohriz:review-votes-rendered', restore);
  window.addEventListener('storage', event => {
    if (event.key !== 'jdgm_thumb_votes' && event.key !== null) return;
    const stored = storedVotes();
    for (const [id, record] of Object.entries(stored)) {
      if (pending.has(id) || records.get(id)?.submitted) continue;
      if (record?.submitted || record?.unconfirmed) {
        records.set(id, record);
        feedback.delete(id);
      }
    }
    restore();
  });
  const submitVote = async button => {
    const group = button.closest('[data-review-votes]'), id = group?.dataset.reviewVotes;
    if (!id || pending.has(id)) return;
    const prior = records.get(id) || storedVotes()[id];
    if (prior?.submitted || prior?.unconfirmed) { restore(); return; }
    const direction = button.dataset.rhpVote;
    if (!['up', 'down'].includes(direction)) return;
    pending.add(id);
    // Save before sending: navigation cannot turn an in-flight POST into a safe retry.
    save(id, { unconfirmed: true });
    feedback.set(id, 'Saving your vote…');
    restore();
    const timer = window.setTimeout(() => {
      slow.add(id);
      feedback.set(id, 'Still waiting for confirmation. Please do not submit another vote.');
      restore();
    }, 15000);
    try {
      const response = await fetch('https://judge.me/thumbs', {
        method: 'POST', body: new URLSearchParams({ review_uuid: id, thumb_type: direction })
      });
      if (!response.ok) throw new Error('Vote failed');
      const count = group.querySelector(`[data-vote-count="${direction}"]`);
      count.textContent = String(Number(count.textContent) + 1);
      const record = { up: Number(group.querySelector('[data-vote-count="up"]').textContent), down: Number(group.querySelector('[data-vote-count="down"]').textContent), submitted: true, direction };
      save(id, record);
      feedback.set(id, 'Thank you for your feedback.');
    } catch {
      // Neither a network error nor a server error proves that the POST was not applied.
      feedback.set(id, unconfirmed);
    } finally {
      window.clearTimeout(timer);
      pending.delete(id);
      slow.delete(id);
      restore();
    }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-rhp-vote]');
    const id = button?.closest('[data-review-votes]')?.dataset.reviewVotes;
    if (!id) return;
    const locks = window.navigator?.locks;
    if (!locks) return submitVote(button);
    try {
      await locks.request(`lohriz-review-vote:${id}`, { ifAvailable: true }, async lock => {
        if (lock) return submitVote(button);
        // Never queue a second POST behind an in-flight vote from another tab.
        restore();
      });
    } catch {
      feedback.set(id, 'Voting could not start. Please try again.');
      restore();
    }
  });
})();
